#import "../fragments/AutomationFields.graphql"

mutation UpdateBroadcast($id: ID!, $input: BroadcastInput!) {
  updateBroadcast(id: $id, input: $input) {
    ...AutomationFields
  }
}
